export const MODES = [
  { id: "jixxeo_lens",       label: "Lens",       icon: "Sparkles",  color: "#00E5FF", desc: "Universal AI scanner" },
  { id: "plant_doctor",      label: "Plant",      icon: "Leaf",      color: "#10B981", desc: "Species ID & care" },
  { id: "animal_id",         label: "Animal",     icon: "PawPrint",  color: "#F59E0B", desc: "Wildlife & breeds" },
  { id: "food_scanner",      label: "Food",       icon: "Utensils",  color: "#F97316", desc: "Calories & macros" },
  { id: "translator_vision", label: "Translate",  icon: "Languages", color: "#38BDF8", desc: "Text translation" },
  { id: "ai_portrait",       label: "Portrait",   icon: "Camera",    color: "#EC4899", desc: "Style transform" },
  { id: "meal_maker",        label: "Meal",       icon: "ChefHat",   color: "#84CC16", desc: "Recipe from pantry" },
  { id: "repair_mode",       label: "Repair",     icon: "Wrench",    color: "#EAB308", desc: "Fix & diagnose" },
];

export const MODE_MAP = Object.fromEntries(MODES.map((m) => [m.id, m]));
